////////////////////////////////////////////////////////////////////////////////
// Ease Methods
////////////////////////////////////////////////////////////////////////////////

/**
 * List of useful easing methods
 *
 * @see hhttp://www.gizma.com/easing/#cub3
 *
 * @author Robert Penner <https://www.linkedin.com/in/robertpenner/>
 *
 * @license Copyright 2019 Robert Penner
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Math.linear = (t, b, c, d) => {
	return c*t/d + b;
}

// quadratic easing in - accelerating from zero velocity
Math.easeInQuad = (t, b, c, d) => {
	t /= d;
	return c*t*t + b;
}

// quadratic easing out - decelerating to zero velocity
Math.easeOutQuad = (t, b, c, d) => {
	t /= d;
	return -c * t*(t-2) + b;
}

// quadratic easing in/out - acceleration until halfway, then deceleration
Math.easeInOutQuad = (t, b, c, d) => {
	t /= d/2;
	if (t < 1) return c/2*t*t + b;
	t--;
	return -c/2 * (t*(t-2) - 1) + b;
}

// cubic easing in - accelerating from zero velocity
Math.easeInCubic = (t, b, c, d) => {
	t /= d;
	return c*t*t*t + b;
}

// cubic easing out - decelerating to zero velocity
Math.easeOutCubic = (t, b, c, d) => {
	t /= d;
	t--;
	return c*(t*t*t + 1) + b;
}

// cubic easing in/out - acceleration until halfway, then deceleration
Math.easeInOutCubic = (t, b, c, d) => {
	t /= d/2;
	if (t < 1) return c/2*t*t*t + b;
	t -= 2;
	return c/2*(t*t*t + 2) + b;
}

// quartic easing in - accelerating from zero velocity
Math.easeInQuart = (t, b, c, d) => {
	t /= d;
	return c*t*t*t*t + b;
}

// quartic easing out - decelerating to zero velocity
Math.easeOutQuart = (t, b, c, d) => {
	t /= d;
	t--;
	return -c * (t*t*t*t - 1) + b;
}

// quartic easing in/out - acceleration until halfway, then deceleration
Math.easeInOutQuart = (t, b, c, d) => {
	t /= d/2;
	if (t < 1) return c/2*t*t*t*t + b;
	t -= 2;
	return -c/2 * (t*t*t*t - 2) + b;
}

// quintic easing in - accelerating from zero velocity
Math.easeInQuint = (t, b, c, d) => {
	t /= d;
	return c*t*t*t*t*t + b;
}

// quintic easing out - decelerating to zero velocity
Math.easeOutQuint = (t, b, c, d) => {
	t /= d;
	t--;
	return c*(t*t*t*t*t + 1) + b;
}

// quintic easing in/out - acceleration until halfway, then deceleration
Math.easeInOutQuint = (t, b, c, d) => {
	t /= d/2;
	if (t < 1) return c/2*t*t*t*t*t + b;
	t -= 2;
	return c/2*(t*t*t*t*t + 2) + b;
}

// sinusoidal easing in - accelerating from zero velocity
Math.easeInSine = (t, b, c, d) => {
	return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
}

// sinusoidal easing out - decelerating to zero velocity
Math.easeOutSine = (t, b, c, d) => {
	return c * Math.sin(t/d * (Math.PI/2)) + b;
}

// sinusoidal easing in/out - accelerating until halfway, then decelerating
Math.easeInOutSine = (t, b, c, d) => {
	return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
}

// exponential easing in - accelerating from zero velocity
Math.easeInExpo = (t, b, c, d) => {
	return c * Math.pow( 2, 10 * (t/d - 1) ) + b;
}

// exponential easing out - decelerating to zero velocity
Math.easeOutExpo = (t, b, c, d) => {
	return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
}

// exponential easing in/out - accelerating until halfway, then decelerating
Math.easeInOutExpo = (t, b, c, d) => {
	t /= d/2;
	if (t < 1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
	t--;
	return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
}

// circular easing in - accelerating from zero velocity
Math.easeInCirc = (t, b, c, d) => {
	t /= d;
	return -c * (Math.sqrt(1 - t*t) - 1) + b;
}

// circular easing out - decelerating to zero velocity
Math.easeOutCirc = (t, b, c, d) => {
	t /= d;
	t--;
	return c * Math.sqrt(1 - t*t) + b;
}

// circular easing in/out - acceleration until halfway, then deceleration
Math.easeInOutCirc = (t, b, c, d) => {
	t /= d/2;
	if (t < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
	t -= 2;
	return c/2 * (Math.sqrt(1 - t*t) + 1) + b;
}
